import {
  IonButton, IonButtons, IonImg, IonLabel,
} from '@ionic/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LocalizedOrderImg from '@/assets/imgs/entry-shop-error-found.svg';
import { ManagedModalRoutes } from '@/interfaces/ManagedModalInterface/ManagedModalInterface';
import { saveOrderManagedData } from '@/redux/orderManaged/orderManaged';
import { postOrderCall, resumptions, retakes } from '@/redux/orderManaged/orderManagedAPI';
import { NotificationType, OrderDetailsResponseContent } from '@/redux/orderManaged/orderManagedInterface';
import { RootState } from '@/store';

import styles from './Order.module.scss';

interface OrderAlreadyAssociatedProps {
  handleLoading: (arg0: boolean) => void;
  sendIFrameUrl: (arg0: string) => void;
  nextStep: (arg0: ManagedModalRoutes) => void;
}

export default function OrderAlreadyAssociated({ handleLoading, sendIFrameUrl, nextStep }: OrderAlreadyAssociatedProps) {
  const dispatch = useDispatch();
  const operationData = useSelector((state: any) => state.operation.data);
  const orderData = useSelector((state: RootState) => state.orderData.data?.data);

  const retakenECO = sessionStorage.getItem('retaken-eco') || false;

  const handleContinue = async () => {
    // console.log('orderData', orderData);
    // TODO: lOGICA PARA RETOMACION
    try {
      if (orderData) {
        await postOrder();
      } else if (operationData && operationData.data && retakenECO) {
        const response = await retakes(orderData!, operationData.order.order_id);
        // console.log('OrderAlreadyAssociated - RETAKES COMPLETADO: ', response);
        // nextStep(ManagedModalRoutes.ORDER_PERSONAL_DATA);
        if (response) await postOrder();
      }
    } catch (error: any) {
      handleLoading(false);
      console.log('Error', error);
    }
  };

  const fetchIframeUrl = async (orderDetails: OrderDetailsResponseContent) => {
    const resumptionDetails = await resumptions(NotificationType.EMAIL, orderDetails.order_id);
    const url = `${resumptionDetails?.url_access}&isechop=1`;
    sendIFrameUrl(url);
  };

  const postOrder = async () => {
    if (orderData) {
      const orderDataModified: OrderDetailsResponseContent = {
        ...orderData,
        order_id: orderData?.order_id,
        process_type: 'MANAGED',
        view_mode: 'IFRAME',
      };
      const postOrder = (await postOrderCall(orderDataModified)).data;
      dispatch(saveOrderManagedData({ data: postOrder }));
      fetchIframeUrl(postOrder);
    } else {
      nextStep(ManagedModalRoutes.UNKNOWN_ERROR);
    }
  };
  return (
    <div className={styles.modalOrderContainer}>
      <div className={styles.orderTitleDescriptionWrapper}>
        <div className={styles.orderTitleWrapper}>
          <IonLabel className={styles.modalOrderTitle}>¡Vaya!</IonLabel>
        </div>
        <div className={styles.orderTitleWrapper}>
          <IonLabel className={styles.modalOrderDescription}>
            Este pedido ya está asociado a una operación existente.
            ¿Deseas continuar con esta operación?
          </IonLabel>
        </div>
      </div>
      <div className={styles.orderImgWrapper}>
        <IonImg src={LocalizedOrderImg} className={styles.sizeImage} />
      </div>
      <div className={styles.modalAlreadyButtonsWrapper}>
        <IonButtons className={styles.nextBtnWrapper}>
          <IonButton className="nextButton" onClick={handleContinue} disabled={false}>Continuar</IonButton>
        </IonButtons>
      </div>
    </div>
  );
}
